import type { SupUiTheme } from "@/hooks/useTheme";
import React, { Fragment } from "react";

import { SupEye } from "@repo/core-ui";
import { SupOption, SupSelect, SupText } from "@repo/core-ui";

interface ThemeToggleProps {
  theme?: SupUiTheme;
  onToggle?: (theme: SupUiTheme) => void;
}

const ALLOWED_THEMES = ["light", "dark"];

export default function ThemeToggle({ theme, onToggle }: ThemeToggleProps) {
  function handleSelect(value: SupUiTheme) {
    onToggle?.(value);
  }

  return (
    Boolean(theme) && (
      <div className="flex items-center">
        <SupSelect
          value={theme ?? "dark"}
          className="relative h-5 w-fit whitespace-nowrap border-none bg-transparent pl-0.5 hover:bg-transparent focus:bg-transparent active:bg-transparent [&.disabled]:bg-transparent [&.disabled]:text-neutral-300"
          popoverClassName="p-0 min-w-36"
          popoverContentClassName="p-0"
          onSelect={handleSelect}
          renderSelectedOption={() => (
            <Fragment>
              <SupEye />
              <SupText variant="caption" className="infline-flex ml-1 text-base md:hidden">
                Switch Theme
              </SupText>
            </Fragment>
          )}
          renderOptionLabel={option => (
            <SupText variant="caption" className="w-full text-base md:text-[12px]">
              {option.label}
            </SupText>
          )}
          optionClassName="h-6 p-2"
        >
          {ALLOWED_THEMES.map(singleTheme => (
            <SupOption key={`ui-theme-${singleTheme}`} label={singleTheme} value={singleTheme} />
          ))}
        </SupSelect>
      </div>
    )
  );
}
